"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsCart = {
  init: function init($section) {
    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));
    this.$section = $section;
    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).data('line-item-key');

      var groupID = $(this).parents('[data-line-item]').data('product-group-id');
      var variantList = [];
      
      document.querySelectorAll(`[data-product-group-id='${groupID}']`).forEach(function(item) {
        variantList.push($(item).data('cart-item'))
      })
	
      console.log('idGroup',$(this).parents('[data-line-item]').find('input[name="io-order-group"]'));
      let idGroup = parseInt($(this).parents('[data-line-item]').find('input[name="io-order-group"]').val());
      let idParentGroup = parseInt($('.cart__card').find(`input[name="io-parent-order-group"][value='${idGroup}']`).val());
      console.log('idParentGroup',$('.cart__card').find(`input[name="io-parent-order-group"][value='${idGroup}']`));
      let variantID = $(this).parents('[data-line-item]').data('cart-item');
      let guestFee;
      let fees = [];

      let list = $(`input[name='io-parent-order-group'][value='${idGroup}']`)
      console.log('lists', list)
      console.log('lineId',lineID);
      console.log('idParentGroup', idParentGroup)
      console.log('itemGroup',idGroup)
      for(let i = 0; i < $(list).length; i++){
        if($(list[i]).val() == idGroup){
          let attr = $(list[i]).parents('div.cart__card')
          console.log('list',$(list[i]).val())
          console.log('listEl', $(list[i]));
          fees.push($(attr).data('cart-item'))
        }
      }
      
      console.log('fees',fees)
      let listID = [];      
      let formData = {};
      if (idGroup === idParentGroup) {
        listID.push(variantID)
        for (var i of fees) {
          listID.push(i);
        }
        
        var productBookingID;
        for (productBookingID in listID) {
          formData[String(listID[productBookingID])] = 0;
          
        }
//         console.log('listId',listID)
//         for (let i = 0; i < listID.length; i++){
//           jQuery.post('/cart/change.js', { quantity: 0, id: listID[i] });
//         }
        console.log(formData);
        Shopify.theme.jsCart.removeBookingFromCart(formData);
      }else{

        if (variantList.length <= 1) {
          Shopify.theme.jsCart.removeFromCart(lineID);
        } else {
          Shopify.theme.jsCart.removeFromCartWithGuestFee(lineID, variantList);
        }
      }
      return false;
    }); // Prevent the ajax cart form from being submitted when pressing the "Enter" key

    $('#cart_form').keydown(function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },

  removeFromCart: function removeFromCart(lineID) {
    var $cartItem = Shopify.theme.jsCart.$section.find("[data-line-item=\"".concat(lineID, "\"]"));
    $cartItem.css('opacity', '0.5');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        $cartItem.addClass('animated zoomOut');
        $cartItem.remove();
        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },

  removeFromCartWithGuestFee: function removeFromCartWithGuestFee(lineID, variantList) {

    var updateData = {}
    for(var i=0; i < variantList.length; i++){
      var item = variantList[i];
      updateData[item] = 0;
    }

    console.log(updateData)

    var $cartItem = Shopify.theme.jsCart.$section.find("[data-line-item=\"".concat(lineID, "\"]"));
    $cartItem.css('opacity', '0.5');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: updateData
      },
      dataType: 'json',
      success: function(cart) {
        $cartItem.addClass('animated zoomOut');
        $cartItem.remove();
        Shopify.theme.jsCart.updateView(cart,  variantList[0]);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  
  removeBookingFromCart: function removeBookingFromCart(formData) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: formData },
      dataType: 'json',
      success: function success(cart) {
        Shopify.theme.jsCart.updateView(cart, formData);
        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },

  updateView: function updateView(cart, lineID) {
    if (cart.item_count > 0) {
      var _$$ajax;

      $.ajax((_$$ajax = {
        dataType: "json",
        async: false,
        cache: false
      }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
        if (lineID !== null) {
          var updatedItems = $(html).find('.cart__item-list .cart__card');
          var currentItems = $('.cart__item-list .cart__card'); // Checks if BOGO applied and there is a change in the number of line items

          if (updatedItems.length != currentItems.length) {
            var updatedCartList = $(html).find('.cart__item-list'); // Re-append cart items

            $('.cart__item-list').replaceWith(updatedCartList);
          }

          $(currentItems).each(function (index, element) {
            $(element).attr('data-line-item', index + 1);
            $(element).find('[data-line-item-key]').attr('data-line-item-key', index + 1);
          });
          var itemTotal = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__total');
          var quantityInput = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-input');
          var itemPrice = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__price');
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__total').replaceWith(itemTotal);
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-input').replaceWith(quantityInput);
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__price').replaceWith(itemPrice);
        }

        var subtotal = $(html).find('.cart__subtotal-container');
        var discounts = $(html).find('.cart__discounts');
        var savings = $(html).find('.cart__total-savings');
        $('.cart__subtotal-container').replaceWith(subtotal);

        if (discounts.length > 0 && $('.cart__discounts').length < 1) {
          $('.cart__subtotal-container').before(discounts);
        } else {
          $('.cart__discounts').replaceWith(discounts);
        }

        if (savings.length > 0 && $('.cart__total-savings').length < 1) {
          $('.cart__subtotal-container').after(savings);
        } else {
          $('.cart__total-savings').replaceWith(savings);
        }

        $('[data-bind="itemCount"]').text(cart.item_count);
      }), _$$ajax));
    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
};